import { useNavigate } from "react-router-dom";
import Box from '@mui/material/Box';
import * as Yup from 'yup'
import OutlinedTextField from '../../../components/formFields/OutlinedTextField';
import { Form, Formik } from "formik";
import SearchIcon from '@mui/icons-material/Search';
import IconButton from '@mui/material/IconButton';
import SearchVehiclesContext from "./SearchVehiclesContext";
import UnitsApi from "../../../api/UnitsApi";

const validationSchema = Yup.object().shape({
  domain: Yup.string()
    .min(6, `screens.searchVehicles.sections.searchDomain.fieldminCharacters`)
})

export default function() {
  const navigate = useNavigate();

  return (
    <SearchVehiclesContext.Consumer>
      { context => {
        const handleSubmit = (values: any, actions: any) => {
          UnitsApi.get(values.domain).then(it => {
            if (it.status !== 200) {
              context.open = true
              actions.resetForm()
              context.refresh()
            } else {
              navigate(`/web/unit-detail/${values.domain}`, { replace: true })
            }
          })
        }

        return (
          <Box className='search-vehicles-card'>
            <Formik
              initialValues={{domain: ''}}
              onSubmit={handleSubmit}
              validationSchema={validationSchema}
              isInitialValid={false}
            >
              {({ isSubmitting, isValid }) => (
                <Form id="domai-search" style={{display: 'flex', alignItems: 'flex-start'}}>
                  <OutlinedTextField
                    label={`screens.searchVehicles.sections.searchDomain.fieldPlaceholder`}
                    extraLabel={`screens.searchVehicles.sections.searchDomain.fieldHelpText`}
                    name="domain"
                    autoComplete="domain"
                    fullWidth={true}
                    i18n
                    sx={{marginRight: '10px'}}
                  />
                  <IconButton disabled={!isValid || isSubmitting} type="submit" className='search-vehicles-icon-button'>
                    <SearchIcon />
                  </IconButton>
                </Form>
              )}
            </Formik>
          </Box>
        )
      }}
    </SearchVehiclesContext.Consumer>
  );
}
